<app-menu></app-menu>
<nav mat-tab-nav-bar mat-align-tabs="center" *ngIf="auth.loggedIn | async">
  <ng-container *ngFor="let link of links">
    <a mat-tab-link [class.active-link]="activeLink == link.name"
      *ngIf="link.name === 'Download' || (link.name === 'Authorize' && (auth.internal | async)) || (link.name === 'Share' && (auth.authorized | async)) || (link.name === 'Translate' && (auth.internal | async))"
      (click)="activeLink = link.name" [active]="activeLink == link.name" [routerLink]="[link.link]">
      <mat-icon fontSet="material-icons-outlined">{{link.icon}}</mat-icon>
      <span>{{link.name}}</span>
    </a>
  </ng-container>
</nav>
<router-outlet></router-outlet>